import get from 'lodash/get';

export default function transformVenue(venue) {
  return {
    ...venue,
    logo: get(venue, 'logo.url', ''),
    address: ['address', 'city', 'state', 'postal']
      .map((key) => get(venue, `location.${key}`, ``))
      .filter((v) => v)
      .join(', '),
  };
}
